import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Toast } from 'primereact/toast';
import { ProgressSpinner } from 'primereact/progressspinner';
import { CompetitionService } from '../../service/CompetitionService';
import { translatedMessage } from '../../service/LanguageService';
import { useParams } from 'react-router-dom';

import CompetitionToolbar from '../competition/CompetitionToolbar';
import CommitteeListComponent from '../../components/committee/CommitteeListComponent';
import CompetitionUtils from '../../utilities/CompetitionUtils';

const CommitteeList = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [competition, setCompetition] = useState(null);

    const toast = useRef(null);
    const { competitionIdParam } = useParams();
    const competitionService = useMemo(() => new CompetitionService(), []);

    useEffect(() => {
        setIsLoading(true);        

        const getCompetition = async () => {
            await competitionService.getCompetition(competitionIdParam)
                .then((competitionData) => {
                    setCompetition(competitionData);
                    setIsLoading(false);  
                })
                .catch((error) => toast.current.show({ severity: 'error', summary: translatedMessage(error), life: 5000 }));
        };

        getCompetition()
    }, [competitionService, competitionIdParam]);


    if (isLoading) {
        return (
            <div className="w-full flex align-items-center">
                <Toast ref={toast} />
                <ProgressSpinner />
            </div>
        );
    } else {
        return (
            <>
                <Toast ref={toast} />
                <div className="grid h-full">
                    <div className="col-12">
                        <div className="card h-full">
                            <CompetitionToolbar competition={competition} code="COMMITTEE"/>

                            <CommitteeListComponent 
                                competition={competition} 
                                viewCommitteeLink={`/competition${CompetitionUtils.isJobCompetition(competition?.type) ? "-job" : ""}/${competition.id}/committee`} 
                                canEdit={true}                                
                                warningMessage={"competition.job.committee.warning"}
                                infoMessage={"competition.job.committee.info"}
                            />
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default CommitteeList;
